import { FC, ReactNode } from 'react';
// 组件
import { ProInput, ProInputNumber, ProSelect } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import FormItem from './subpage/formItem';
// 方法
import classNames from 'classnames';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
import { getInputPlaceholder, getSelectPlaceholder } from '../utils/ruleUtils';
import { filterEmptyValue } from '../utils/utils';
import { renderEnumName } from '../utils/renderUtils';
// 常量
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { TextAreaProps } from 'antd/es/input';
import { IBaseItem, combinationItemType } from './combination';
import { TABLE_COLUMN_EMPTY } from '../constants/constant';

interface ITextAreaItem extends IBaseItem {
  formItemType: 'TextArea';
  textAreaPropsProps?: TextAreaProps;
}

export type RowsOptionsType = combinationItemType | ITextAreaItem;
export interface SearchFormRowsProps extends BaseSearchFormItemProps {
  /** 是否必传 */
  allRequired?: boolean;
  /** 是否禁用 */
  disabled?: boolean;
  /** 多行表单配置 */
  rowsOptions?: RowsOptionsType[][];
}
/** 多行表单组合 */
export const SearchFormRows: FC<SearchFormRowsProps> = props => {
  const {
    render,
    disabledRender,
    isDetail,
    isTable,
    testId,
    rules,
    label,
    name,
    form,
    className,
    allRequired,
    required,
    hideLabel,
    disabled,
    rowsOptions,
    ...resProps
  } = props;
  const { enumData } = useLayoutContext();
  const classes = classNames(className, {
    'address-required': allRequired || required,
  });
  const renderChildren = (item: RowsOptionsType) => {
    switch (item.formItemType) {
      case 'CustomItem':
        return item.render;
      case 'TextArea':
        return (
          <ProInput.TextArea
            style={{ width: '100%' }}
            {...item.textAreaPropsProps}
            placeholder={getInputPlaceholder(
              item.label,
              item.textAreaPropsProps,
              item.formItemProps?.rules,
            )}
          />
        );
      case 'InputNumber':
        return (
          <ProInputNumber
            style={{ width: '100%' }}
            company={item.company}
            companyWidth={item.companyWidth}
            {...item.inputNumberProps}
            placeholder={getInputPlaceholder(
              item.label,
              item.inputNumberProps,
              item.formItemProps?.rules,
            )}
          />
        );
      case 'Select':
        let options: any[] = [];
        if (item.enumCode && enumData) {
          options = enumData[item.enumCode]?.items ?? [];
        }
        return (
          <ProSelect
            style={{ width: '100%' }}
            options={options}
            {...item.selectProps}
            placeholder={getSelectPlaceholder(
              item.label,
              item.selectProps,
              item.formItemProps?.rules,
            )}
          />
        );
      default:
        return (
          <ProInput
            style={{ width: '100%' }}
            company={item.company}
            companyWidth={item.companyWidth}
            {...item.inputProps}
            placeholder={getInputPlaceholder(
              item.label,
              item.inputProps,
              item.formItemProps?.rules,
            )}
          />
        );
    }
  };
  const renderText = (): ReactNode => {
    if (disabledRender) {
      return typeof disabledRender === 'function' ? disabledRender() : disabledRender;
    }
    return rowsOptions?.map((rowOptions, rowIndex) => {
      return (
        <div key={rowIndex} style={{ display: 'flex', width: '100%', marginBottom: 12, lineHeight: '32px' }}>
          {
            rowOptions.map((option, columnIndex) => {
              let val = form?.getFieldValue?.(option.formItemProps?.name as string);
              if (option.formItemType === 'CustomItem' && option.disabledRender) {
                val = option.disabledRender;
              }
              if (option.formItemType === 'Select' && val !== undefined) {
                let options: any[] = option.selectProps?.options ?? [];
                if (option.enumCode && enumData) {
                  options = enumData[option.enumCode]?.items ?? [];
                }
                val = renderEnumName(val, options) || val;
              }
              if (typeof val !== 'string') {
                val === TABLE_COLUMN_EMPTY;
              }
              return (
                <div
                  key={columnIndex}
                  style={{
                    marginRight: option.marginRight === undefined ? (columnIndex !== rowOptions.length - 1 ? 15 : 0) :option.marginRight,
                  }}
                >
                  {
                    !!option.label && <span>{option.label}：</span>
                  }
                  <span>
                    {filterEmptyValue(val)}
                  </span>
                </div>
              );
            })
          }
        </div>
      );
    });
  }
  return (
    <SearchFormItem
      {...resProps}
      className={classes}
      label={!hideLabel && label}
    >
      {isDetail || disabled ? (
        <SearchFormDisabled render={renderText} form={form} isTable={isTable} />
      ) : (
        rowsOptions?.map((rowsOption, rowIndex) => {
          return (
            <div key={rowIndex} style={{ display: 'flex', width: '100%', }}>
              {
                rowsOption.map((option, columnIndex) => {
                  return (
                    <FormItem
                      key={columnIndex}
                      style={{
                        flex: option.flex || 1,
                        marginRight: option.marginRight === undefined ? (columnIndex !== rowsOption.length - 1 ? 15 : 0) :option.marginRight,
                      }}
                      {...option.formItemProps}
                    >
                      {renderChildren(option)}
                    </FormItem>
                  );
                })
              }
            </div>
          );
        })
      )}
    </SearchFormItem>
  );
};

SearchFormRows.displayName = SearchFormItemEnum.SearchFormRows;

export default SearchFormRows;
